import { render } from "./VerifyImages.vue?vue&type=template&id=1883ea9f&ts=true"
import script from "./VerifyImages.vue?vue&type=script&lang=ts"
export * from "./VerifyImages.vue?vue&type=script&lang=ts"

import "./VerifyImages.vue?vue&type=style&index=0&id=1883ea9f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__